import React, { useEffect, useRef, useState } from "react";
import { Button, FormLabel, FormElement, FormInput, CancelButton } from "../../../../../components/StyledElements";
import Checkbox from "../../../../../components/Elements/Checkbox";
import { RejectionBlock } from "../../../../../components/RejectionBlock";
import swal from "sweetalert2";
import { updateQuestion, deleteQuestion } from "../../../../../services/courses";
import { Icon } from "@iconify/react";

export const EditQuiz = ({ levelSection, onUpdateQuestion = () => { }, style = {} }) => {

  const quizContainerRef = useRef(null);

  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [currentQuestion, setCurrentQuestion] = useState();
  const [updatedQuestion, setUpdatedQuestion] = useState();
  const [savingQuestion, setSavingQuestion] = useState(false);
  //
  //  
  useEffect(() => {

    const r = window.addEventListener("resize", () => {
      if (quizContainerRef.current) {
        const newContainerWidth = quizContainerRef.current.getBoundingClientRect().width;
        const offset = (currentQuestion + 1) * (newContainerWidth + 10);
        quizContainerRef.current.scrollTo({ left: offset, behavior: "smooth" });
      }
    });

    return () => {
      window.removeEventListener("resize", r);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (levelSection?.quiz?.questions) {
      const currentQuestion = levelSection.quiz.questions[currentQuestionIndex];
      setCurrentQuestion(currentQuestion);
      setUpdatedQuestion(currentQuestion);

    }
  }, [currentQuestionIndex, levelSection?.quiz?.questions]);

  useEffect(() => {
    // Get the current hash from the URL and set the current question accordingly
    if (!levelSection?.quiz?.questions || levelSection.quiz.questions.length === 0) {
      return;
    }

    const hash = window.location.hash;
    const parts = hash.split("&");
    console.log("!!! QUESTION pARTS: ", parts);
    if (parts.length > 0 && parts[0] === "#quiz") {
      if (parts && parts.length > 1) {
        if (!parts[1].match(/^\d+$/)) {
          console.log("!!! QUESTION ID: ", parts[1]);
          const questionIndex = levelSection.quiz.questions.findIndex((q) => q.public_id === parts[1]);
          console.log("!!! QUESTION INDEX: ", questionIndex);
          if (questionIndex !== -1) {
            setCurrentQuestionIndex(questionIndex);
            const offset = questionIndex * (quizContainerRef.current.getBoundingClientRect().width + 10);
            quizContainerRef.current.scrollTo({ left: offset });
            return;
          } else {
            console.log("!!! QUESTION NOT FOUND: ", parts[1]);
          }

        }

        const questionIndex = parseInt(parts[1]);
        console.log("!!! question INDEX: ", questionIndex);
        if (!isNaN(questionIndex) && questionIndex > 0 && questionIndex <= levelSection?.quiz?.questions?.length) {
          setCurrentQuestionIndex(questionIndex - 1);
          const offset = (questionIndex - 1) * (quizContainerRef.current.getBoundingClientRect().width + 10);
          quizContainerRef.current.scrollTo({ left: offset });
        }
      } else {
        console.log("!!! CHANGING TO QUIZ 1")
        window.history.replaceState(null, null, `#quiz&1`);
        setCurrentQuestionIndex(0);
        quizContainerRef.current.scrollTo({ left: 0 });
      }
    }
  }, [levelSection?.quiz?.questions]);

  const hasChanged = () => {
    if (!currentQuestion || !updatedQuestion) {
      return false;
    }

    return JSON.stringify(currentQuestion) !== JSON.stringify(updatedQuestion);
  }


  return (
    <div style={{ display: "flex", flexDirection: "column", ...style }}>
      <div style={{ position: "absolute", top: 20, right: 20, display: "flex", zIndex: 200, flexDirection: "row", gap: "10px" }}>
        <CancelButton onClick={() => {
          swal.fire({
            title: "Are you sure?",
            text: "Any unsaved changes will be lost.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, cancel",
            cancelButtonText: "No, keep editing",
          }).then((result) => {
            console.log("!!! RESULT: ", result);
            if (result?.value) {
              setUpdatedQuestion(currentQuestion);
            }
          });
        }}>Cancel</CancelButton>
        <Button disabled={!hasChanged() || savingQuestion} style={{ marginLeft: "auto" }}
          onClick={async () => {
            if (!hasChanged()) {
              return;
            }


            // open a sweetalert2 modal until the save is complete
            swal.fire({
              title: "Saving...",
              text: "Please wait while the content block is being saved.",
              allowOutsideClick: false,
              didOpen: () => {
                swal.showLoading();
              },
            });

            setSavingQuestion(true);
            const results = await updateQuestion(updatedQuestion);
            setSavingQuestion(false);

            if (results.success) {
              //const newUpdatedBlock = results.content_block;
              setCurrentQuestion(updatedQuestion);
              onUpdateQuestion({ ...results.question }, false);

              swal.fire({
                title: "Success",
                text: "Content block saved successfully.",
                icon: "success",
              });
            } else {
              swal.fire({
                title: "Error",
                text: results.error || "An error occurred while saving the content block.",
                icon: "error",
              });
            }
          }}
        >
          {savingQuestion ? "Saving Question..." : "Save Question"}
        </Button>
      </div>
      <div style={{ display: "flex", flexDirection: "row", justifyQuiz: "space-between", alignItems: "center", marginBottom: "10px" }}>
        <FormLabel label={`Quiz Question ${currentQuestionIndex + 1} of ${levelSection?.quiz?.questions?.length}`} />
        <FormLabel style={{ marginLeft: "10px" }} label={`(${levelSection?.quiz?.questions?.[currentQuestionIndex]?.type ?? "N/A"})`} />

        <div style={{ marginLeft: "auto", display: "flex", flexDirection: "row", gap: "10px" }}>
          <Icon icon="mdi:delete" height={20} width={20} style={{ cursor: "pointer", color: "var(--error-color)" }} onClick={() => {
            swal.fire({
              title: "Are you sure?",
              text: "This will delete the current question. This action cannot be undone.",
              icon: "warning",
              showCancelButton: true,
              confirmButtonText: "Yes, delete it",
              cancelButtonText: "No, keep it",
            }).then(async (result) => {
              if (result?.value) {
                const results = await deleteQuestion(currentQuestion.public_id);
                if (results.success) {
                  swal.fire({
                    title: "Deleted!",
                    text: "The question has been deleted.",
                    icon: "success",
                  });
                  // Remove the question from the levelSection.quiz.questions array
                  onUpdateQuestion({ ...currentQuestion }, true);
                } else {
                  swal.fire({
                    title: "Error",
                    text: results.error || "An error occurred while deleting the question.",
                    icon: "error",
                  });
                }
              }
            });
          }} />
        </div>
      </div>

      <RejectionBlock contentPublicId={currentQuestion?.public_id} />

      <FormElement>
        <FormInput value={currentQuestion?.public_id ?? ""} style={{ backgroundColor: "white" }} disabled />
      </FormElement>

      <div ref={quizContainerRef} id="content-questions-container" style={{ width: "100%", marginBottom: "10px", overflow: "hidden" }}>
        <div style={{ display: "flex", flexDirection: "row", marginBottom: "10px", flowWrap: "nowrap" }}>
          {/*Each content question will be displayed as it's own page, and the wrapper will scroll horizontally to show the next content question*/}
          {levelSection?.quiz?.questions?.map((question, index) => (
            <FormElement key={index} style={{ flex: "0 0 100%", marginRight: "10px" }}>
              <FormInput
                as="textarea"
                value={updatedQuestion?.question ?? ""}
                style={{ width: "100%", height: "80px", resize: "vertical" }}
                onChange={(e) => {
                  setUpdatedQuestion({ ...updatedQuestion, question: e.target.value });
                }}
              />
              {question.type === "multiple_choice" ? (
                <div style={{ display: "flex", flexDirection: "column", marginTop: "10px" }}>
                  {updatedQuestion?.options?.map((option, optionIndex) => (
                    <FormElement key={optionIndex} style={{ flexDirection: "row", alignItems: "center" }}>
                      <Checkbox
                        checked={optionIndex === updatedQuestion.correct_answer ?? false}
                        onChange={(e) => {
                          setUpdatedQuestion({ ...updatedQuestion, correct_answer: e.target.checked ? optionIndex : null });
                        }}
                      />
                      <FormInput
                        type="text"
                        value={option ?? ""}
                        style={{ width: "calc(100% - 34px)", marginLeft: "10px", marginRight: "auto" }}
                        onChange={(e) => {
                          const newOptions = [...updatedQuestion.options];
                          newOptions[optionIndex] = e.target.value;
                          setUpdatedQuestion({
                            ...updatedQuestion, options: newOptions
                          });
                        }}
                      />
                    </FormElement>
                  ))}
                </div>
              ) : null}

              {question.type === "true_false" ? (
                <div style={{ display: "flex", flexDirection: "row", marginTop: "10px" }}>
                  <FormElement style={{ flexDirection: "row", alignItems: "center", marginRight: "20px" }}>
                    <Checkbox
                      checked={question.correct_answer === true}
                      onChange={(e) => {
                        /*const newquestions = [...contentquestions];
                        newquestions[index].correct_answer = e.target.checked;
                        setQuizquestions(newquestions);
                        onUpdated({ ...section, contentquestions: newquestions });*/
                      }}
                    />
                    <FormLabel label="True" style={{ marginLeft: "10px" }} />
                  </FormElement>
                  <FormElement style={{ flexDirection: "row", alignItems: "center" }}>
                    <Checkbox
                      checked={question.correct_answer === false}
                      onChange={(e) => {
                        /*const newquestions = [...contentquestions];     
  *                       newquestions[index].correct_answer = !e.target.checked;
  *                       setQuizquestions(newquestions);
  *                       onUpdated({ ...section, contentquestions: newquestions });*/
                      }}
                    />
                    <FormLabel label="False" style={{ marginLeft: "10px" }} />
                  </FormElement>
                </div>
              ) : null}


              {/* Matching has left_items, and right_items that match each others index, 0->0, 1->1, etc.*/}
              {question.type === "matching" ? (
                <div style={{ display: "flex", flexDirection: "column", marginTop: "10px" }}>
                  {updatedQuestion?.left_items?.map((leftItem, leftIndex) => (
                    <FormElement key={leftIndex} style={{ flexDirection: "row", alignItems: "center", marginBottom: "10px" }}>
                      <FormInput
                        type="textara"
                        value={leftItem ?? ""}
                        style={{ width: "calc(50% - 10px)", marginRight: "10px" }}
                        onChange={(e) => {
                          const newLeftItems = [...updatedQuestion.left_items];
                          newLeftItems[leftIndex] = e.target.value;
                          setUpdatedQuestion({ ...updatedQuestion, left_items: newLeftItems });

                        }}
                      />
                      <FormInput
                        type="textara"
                        value={updatedQuestion?.right_items?.[leftIndex] ?? ""}
                        style={{ width: "calc(50% - 10px)", marginLeft: "10px" }}
                        onChange={(e) => {
                          const newRightItems = [...updatedQuestion.right_items];
                          newRightItems[leftIndex] = e.target.value;
                          setUpdatedQuestion({ ...updatedQuestion, right_items: newRightItems });


                        }}
                      />
                    </FormElement>
                  ))}
                </div>
              ) : null}

            </FormElement>

          ))}
        </div>
      </div>
      <div style={{ width: "100%", display: "flex", flexDirection: "row" }}>
        {currentQuestionIndex > 0 ? (
          <Button style={{ justifySelf: "flex-start" }} onClick={() => {
            const width = quizContainerRef.current.getBoundingClientRect().width;
            const offset = (currentQuestionIndex - 1) * (width + 10);
            setCurrentQuestionIndex(currentQuestionIndex - 1);
            quizContainerRef.current.scrollTo({ left: offset, behavior: "smooth" });
            window.history.replaceState(null, null, `#quiz&${currentQuestionIndex - 1}`);
          }}>Previous</Button>
        ) : null}
        {
          currentQuestionIndex < levelSection?.quiz?.questions?.length - 1 ? (
            <Button style={{ justifySelf: "flex-end", marginLeft: "auto" }} onClick={() => {
              const width = quizContainerRef.current.getBoundingClientRect().width;
              const offset = (currentQuestionIndex + 1) * (width + 10);
              setCurrentQuestionIndex(currentQuestionIndex + 1);
              quizContainerRef.current.scrollTo({ left: offset, behavior: "smooth" });
              // Update the current url hash to reflect the current content question
              window.history.replaceState(null, null, `#quiz&${currentQuestionIndex + 2}`);
            }}>Next</Button>) : null}
      </div>
    </div >
  )
}

export default EditQuiz;
